/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_DescriptionInputs */

const en_directory_platforms_description = /** @type {(inputs: Directory_Platforms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse products that support the platforms represented in the Seek AI directory.`)
};

const zh_directory_platforms_description = /** @type {(inputs: Directory_Platforms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 Seek AI 目录中产品支持的平台进行浏览。`)
};

/**
* | output |
* | --- |
* | "Browse products that support the platforms represented in the Seek AI directory." |
*
* @param {Directory_Platforms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_description = /** @type {((inputs?: Directory_Platforms_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_description(inputs)
	return zh_directory_platforms_description(inputs)
});
export { directory_platforms_description as "directory.platforms.description" }